import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const DRAWER_WIDTH = '368px';

export const SidebarContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  height: calc(100% - var(--app-header-height));
  width: ${DRAWER_WIDTH};
  display: flex;
  flex-direction: column;
  flex: 0 0 ${DRAWER_WIDTH};
  flex-shrink: 0;
  padding: 20px 16px;
  border-left: 1px solid var(--border-soft);
  background-color: var(--background-default);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  z-index: var(--z-index-sidebar);
  ${customScrollMinimal}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  ${typographyV2.titleBase};
`;
